export const UNAVAILABLE_ITEM_DEPARTMENTS = [
  'bar',
  'kitchen',
  'other'
] as const;

export type UnavailableItemDepartment =
  (typeof UNAVAILABLE_ITEM_DEPARTMENTS)[number];

/** Old replicas and queued mutations can still carry the retired department. */
export function normalizeUnavailableItemDepartment<T extends string>(
  department: T
): Exclude<T, 'foh'> | 'other' {
  return (department === 'foh' ? 'other' : department) as
    Exclude<T, 'foh'> | 'other';
}
